export default "__VITE_ASSET__DPB$6IMz__"